import { SignUp } from '@clerk/clerk-react'
import { Box } from '@mui/material'

export const SignupPage = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                pt: '6rem',
                alignItems: 'center',
                width: '100%',
                gap: '1.5rem',
            }}
        >
            <SignUp signInUrl="/auth/login" />
        </Box>
    )
}
